"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var address_row_1 = require("./address_row");
var modal_dialog_1 = require("@reverbdotcom/commons/dist/components/modal_dialog");
var bind_1 = require("../../../bind");
var error_display_1 = require("../../discovery/error_display");
var address_form_data_1 = require("../address_form_data");
var I18n = require("i18n-js");
var shipping_address_1 = require("./shipping_address");
var address_form_1 = require("../address_form");
var with_address_book_apollo_1 = require("../with_address_book_apollo");
var SELECTED_ADDRESS_VIEW = 'selectedAddressView';
var ADDRESS_INDEX = 'addressIndex';
var ADDRESS_FORM = 'addressForm';
var ADDRESS_INPUT_NAME = 'checkout[selected_shipping_address_id]';
var PAGE_SIZE = 5;
var ShippingAddressSelector = /** @class */ (function (_super) {
    tslib_1.__extends(ShippingAddressSelector, _super);
    function ShippingAddressSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.addressFormRef = null;
        _this.state = {
            selectedShippingAddressUuid: props.selectedShippingAddressUuid,
            newSelectedShippingAddressUuid: props.selectedShippingAddressUuid,
            addressFormData: address_form_data_1.buildBlankAddressFormData(),
            saving: false,
            shownAddressCount: PAGE_SIZE,
            addressErrors: [],
            makeAddressPrimary: false,
            uiState: props.autoOpen ? ADDRESS_INDEX : SELECTED_ADDRESS_VIEW,
        };
        return _this;
    }
    ShippingAddressSelector.prototype.componentDidMount = function () {
        // The initial address could have errors, we want to open the modal if that's the case
        this.onLoaded();
    };
    ShippingAddressSelector.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.loading && !this.props.loading) {
            this.onLoaded();
        }
    };
    ShippingAddressSelector.prototype.onLoaded = function () {
        // Once we've loaded the addresses, if checkout redirected back with a submitErrorMessage (eg phone is missing),
        // open the edit form to that address with the error message.
        if (this.props.submitErrorMessage) {
            this.setState({
                addressErrors: [{ message: this.props.submitErrorMessage }],
                uiState: ADDRESS_FORM,
                addressFormData: address_form_data_1.buildAddressFormDataFromAddress(this.selectedShippingAddress),
            });
        }
    };
    Object.defineProperty(ShippingAddressSelector.prototype, "isEditingExistingAddress", {
        get: function () {
            return (this.state.uiState === ADDRESS_FORM &&
                this.state.addressFormData.uuid.length > 0 &&
                !!this.addressCurrentlyEditing);
            /* all these checks are to ensure that we account for any mismatch between
              the state of this component and props passed from Apollo (Apollo cache versus server response)
              eg. deleting an address could get us into a state where we have a nil id for the address
              but we are still trying to render the form */
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingAddressSelector.prototype, "editedAddressIsCurrentPrimary", {
        get: function () {
            return (this.isEditingExistingAddress && this.addressCurrentlyEditing.primary);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingAddressSelector.prototype, "addressCurrentlyEditing", {
        get: function () {
            var _this = this;
            return this.props.addresses.find(function (address) { return address.uuid === _this.state.addressFormData.uuid; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingAddressSelector.prototype, "selectedShippingAddress", {
        get: function () {
            var _this = this;
            return (this.props.addresses.find(function (address) { return address.uuid === _this.state.selectedShippingAddressUuid; }) || this.props.addresses[0]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingAddressSelector.prototype, "newSelectedShippingAddress", {
        get: function () {
            var _this = this;
            return this.props.addresses.find(function (address) { return address.uuid === _this.state.newSelectedShippingAddressUuid; }) || this.props.addresses[0];
        },
        enumerable: true,
        configurable: true
    });
    ShippingAddressSelector.prototype.handleAddNewAddress = function () {
        this.setState({
            addressFormData: address_form_data_1.buildBlankAddressFormData(),
            uiState: ADDRESS_FORM,
        });
    };
    ShippingAddressSelector.prototype.closeModal = function () {
        this.setState({
            addressErrors: [],
            uiState: SELECTED_ADDRESS_VIEW,
        });
    };
    ShippingAddressSelector.prototype.openModal = function () {
        this.setState({
            uiState: ADDRESS_INDEX,
            newSelectedShippingAddressUuid: this.selectedShippingAddress.uuid,
            makeAddressPrimary: false,
        });
    };
    ShippingAddressSelector.prototype.handleUpdateField = function (addressAttributes) {
        this.setState({
            addressFormData: tslib_1.__assign(tslib_1.__assign({}, this.state.addressFormData), addressAttributes),
        });
    };
    ShippingAddressSelector.prototype.handleUpdatePrimary = function () {
        var isPrimary = this.state.makeAddressPrimary;
        this.setState({
            makeAddressPrimary: !isPrimary,
            addressFormData: tslib_1.__assign(tslib_1.__assign({}, this.state.addressFormData), { primary: !isPrimary }),
        });
    };
    ShippingAddressSelector.prototype.handleAddressEdit = function (address) {
        var addressFormData = address_form_data_1.buildAddressFormDataFromAddress(address);
        if (!address.primary && this.state.makeAddressPrimary) {
            addressFormData.primary = true;
        }
        this.setState({
            addressFormData: addressFormData,
            uiState: ADDRESS_FORM,
        });
    };
    ShippingAddressSelector.prototype.handleSubmit = function () {
        if (this.props.loading || this.state.saving) {
            return;
        }
        if (this.state.uiState === ADDRESS_FORM) {
            return this.createOrUpdateAddress();
        }
        this.useSelectedAddress();
    };
    ShippingAddressSelector.prototype.handleShowMore = function (e) {
        e.preventDefault();
        this.setState({
            shownAddressCount: this.state.shownAddressCount + PAGE_SIZE,
        });
    };
    ShippingAddressSelector.prototype.useSelectedAddress = function () {
        if (this.state.makeAddressPrimary) {
            this.setState({ saving: true });
            this.props.onMakePrimary(this.newSelectedShippingAddress);
            this.saveSuccess(this.newSelectedShippingAddress.uuid);
        }
        else {
            this.saveSuccess(this.newSelectedShippingAddress.uuid);
        }
    };
    ShippingAddressSelector.prototype.createOrUpdateAddress = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var form, _a, address, errors, _b, address, errors;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        form = this.addressFormRef;
                        if (form.reportValidity && !form.reportValidity()) {
                            return [2 /*return*/];
                        }
                        if (!this.isEditingExistingAddress) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onUpdate(this.state.addressFormData)];
                    case 1:
                        _a = _c.sent(), address = _a.address, errors = _a.errors;
                        this.handleResponse({ address: address, errors: errors });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.onCreate(this.state.addressFormData)];
                    case 3:
                        _b = _c.sent(), address = _b.address, errors = _b.errors;
                        this.handleResponse({ address: address, errors: errors });
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShippingAddressSelector.prototype.handleResponse = function (_a) {
        var address = _a.address, errors = _a.errors;
        if (address) {
            this.saveSuccess(address.uuid);
        }
        else {
            this.setState({
                addressErrors: errors,
                saving: false,
            });
        }
    };
    ShippingAddressSelector.prototype.saveSuccess = function (addressUuid) {
        var _this = this;
        if (this.isEditingExistingAddress) {
            this.setState({ shownAddressCount: this.state.shownAddressCount + 1 });
        }
        this.setState({
            saving: false,
            uiState: SELECTED_ADDRESS_VIEW,
            selectedShippingAddressUuid: addressUuid,
            addressErrors: [],
        }, function () {
            _this.triggerShippingTotalsRerender(_this.selectedShippingAddress.legacyId);
        });
    };
    ShippingAddressSelector.prototype.triggerShippingTotalsRerender = function (addressLegacyId) {
        // this triggers a refetch for shipping totals in core
        var w = this.props.window || window;
        w.Reverb.BundledCheckout.rerenderTotals(ADDRESS_INPUT_NAME + "=" + addressLegacyId);
    };
    ShippingAddressSelector.prototype.formHeaderTitle = function () {
        if (this.isEditingExistingAddress) {
            return I18n.t('discovery.addressBook.form.title.edit');
        }
        return I18n.t('discovery.addressBook.form.title.create');
    };
    ShippingAddressSelector.prototype.handleChangeSelectedAddress = function (selectedAddressUuid) {
        this.setState({
            makeAddressPrimary: false,
            newSelectedShippingAddressUuid: selectedAddressUuid,
        });
    };
    ShippingAddressSelector.prototype.toggleMakePrimary = function () {
        this.setState({ makeAddressPrimary: !this.state.makeAddressPrimary });
    };
    ShippingAddressSelector.prototype.setAddressFormRef = function (ref) {
        this.addressFormRef = ref;
    };
    Object.defineProperty(ShippingAddressSelector.prototype, "modalProps", {
        get: function () {
            if (this.state.uiState === ADDRESS_INDEX) {
                return {
                    headerTitle: I18n.t('discovery.checkout.addressBook.listView.header'),
                    saveButtonText: I18n.t('discovery.checkout.addressBook.listView.submit'),
                    onBack: null,
                };
            }
            if (this.isEditingExistingAddress) {
                return {
                    headerTitle: I18n.t('discovery.checkout.addressBook.editView.header'),
                    saveButtonText: I18n.t('discovery.checkout.addressBook.editView.submit'),
                    onBack: this.handleModalBack,
                };
            }
            // create address
            return {
                headerTitle: I18n.t('discovery.checkout.addressBook.createView.header'),
                saveButtonText: I18n.t('discovery.checkout.addressBook.createView.submit'),
                onBack: this.handleModalBack,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingAddressSelector.prototype, "shownAddresses", {
        get: function () {
            var _this = this;
            var otherAddresses = this.props.addresses.filter(function (a) { return a.uuid !== _this.selectedShippingAddress.uuid; });
            return [this.selectedShippingAddress].concat(otherAddresses.slice(0, this.state.shownAddressCount - 1));
        },
        enumerable: true,
        configurable: true
    });
    ShippingAddressSelector.prototype.renderAddresses = function () {
        var _this = this;
        var addressList = this.shownAddresses.map(function (address) {
            var selected = address.uuid === _this.newSelectedShippingAddress.uuid;
            return (React.createElement(address_row_1.default, { key: address.uuid, isSelected: selected, address: address, onSelect: _this.handleChangeSelectedAddress, onMakePrimary: _this.toggleMakePrimary, makeAddressPrimary: _this.state.makeAddressPrimary, onEdit: _this.handleAddressEdit }));
        });
        return addressList;
    };
    ShippingAddressSelector.prototype.renderAddressList = function () {
        if (this.props.loading) {
            return this.renderPlaceholderContent();
        }
        return (React.createElement("div", null,
            React.createElement("ul", { className: "actionable-rows" },
                this.renderAddresses(),
                this.renderPagination()),
            React.createElement("div", { className: "mt-2" },
                React.createElement("button", { "data-add-new-address": true, onClick: this.handleAddNewAddress, className: "button" }, I18n.t('discovery.addressBook.addNewBtn')))));
    };
    ShippingAddressSelector.prototype.renderForm = function () {
        return (React.createElement(address_form_1.default, { addressFormData: this.state.addressFormData, countries: this.props.countries, onUpdateField: this.handleUpdateField, addressIsCurrentPrimary: this.editedAddressIsCurrentPrimary, errors: this.state.addressErrors, formRef: this.setAddressFormRef }));
    };
    ShippingAddressSelector.prototype.renderPagination = function () {
        if (this.state.shownAddressCount >= this.props.addresses.length) {
            return null;
        }
        return (React.createElement("li", { className: "actionable-row" },
            React.createElement("div", { className: "actionable-row__content" },
                React.createElement("button", { "data-load-more": true, className: "button-as-link", onClick: this.handleShowMore }, I18n.t('discovery.addressBook.loadMore')))));
    };
    ShippingAddressSelector.prototype.handleModalBack = function () {
        this.setState({
            uiState: ADDRESS_INDEX,
            addressErrors: [],
        });
    };
    ShippingAddressSelector.prototype.renderPlaceholderRow = function () {
        return (React.createElement("li", { className: "actionable-row actionable-row--placeholder" },
            React.createElement("div", { className: "actionable-row__content" }),
            React.createElement("ul", { className: "actionable-row__actions" },
                React.createElement("li", { className: "actionable-row__action" }))));
    };
    ShippingAddressSelector.prototype.renderPlaceholderContent = function () {
        return (React.createElement("div", null,
            React.createElement("ul", { className: "actionable-rows" },
                this.renderPlaceholderRow(),
                this.renderPlaceholderRow(),
                this.renderPlaceholderRow())));
    };
    ShippingAddressSelector.prototype.renderHiddenInput = function () {
        if (this.props.loading) {
            return;
        }
        return (React.createElement("input", { type: "hidden", name: ADDRESS_INPUT_NAME, value: this.selectedShippingAddress.legacyId }));
    };
    ShippingAddressSelector.prototype.render = function () {
        if (this.props.error) {
            return React.createElement(error_display_1.default, null);
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "d-flex fx-justify-between mb-1" },
                React.createElement("h3", { className: "heading-3" }, I18n.t('discovery.checkout.shippingAddress')),
                React.createElement("button", { className: "button-as-link icon-l-pencil", onClick: this.openModal, type: "button" }, I18n.t('discovery.checkout.addressBook.row.actions.change'))),
            React.createElement(shipping_address_1.default, { loading: this.props.loading, address: this.selectedShippingAddress }),
            this.renderHiddenInput(),
            React.createElement(modal_dialog_1.default, tslib_1.__assign({}, this.modalProps, { onRequestClose: this.closeModal, isOpen: this.state.uiState !== SELECTED_ADDRESS_VIEW, onSubmit: this.handleSubmit, isSaving: this.state.saving, backButtonText: I18n.t('discovery.checkout.addressBook.cancel'), containsFormElement: true }),
                React.createElement("div", { className: "shipping-address-selector" },
                    this.state.uiState === ADDRESS_FORM && this.renderForm(),
                    this.state.uiState === ADDRESS_INDEX && this.renderAddressList()))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleAddNewAddress", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "closeModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "openModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleUpdateField", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleUpdatePrimary", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleAddressEdit", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleShowMore", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "saveSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "triggerShippingTotalsRerender", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleChangeSelectedAddress", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "toggleMakePrimary", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "setAddressFormRef", null);
    tslib_1.__decorate([
        bind_1.default
    ], ShippingAddressSelector.prototype, "handleModalBack", null);
    return ShippingAddressSelector;
}(React.Component));
exports.ShippingAddressSelector = ShippingAddressSelector;
var ShippingAddressSelectorWithRQL = with_address_book_apollo_1.default(ShippingAddressSelector);
exports.ShippingAddressSelectorWithRQL = ShippingAddressSelectorWithRQL;
//# sourceMappingURL=shipping_address_selector.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/checkout/shipping_address_selector.js
// module id = UuAN
// module chunks = 20 21